import * as Yup from 'yup';
import moment from 'moment';
export function initialValues(node) {
    return {
        entity: node?.entity || "",
        networkId: node?.networkId || "",
        networkName: node?.networkName || "",
        type: node?.type || "",
        nameTechnicalContact: node?.nameTechnicalContact || "",
        emailTechnicalContact: node?.emailTechnicalContact || "",
        phoneTechnicalContact: node?.phoneTechnicalContact || "",
        nameBussinesContact: node?.nameBussinesContact || "",
        emailBussinesContact: node?.emailBussinesContact || "",
        phoneBussinesContact: node?.phoneBussinesContact || "",
        enode: node?.enode || "",
        ipAddress: node?.ipAddress || "",
        coinbase: node?.coinbase || "",
        portp2p: node?.portp2p || "",
        nodeNameEthstats: node?.nodeNameEthstats || "",
        membership: node?.membership,  //|| "",
        dateSignature: node?.dateSignature || ""
        //dateSignature: moment(node?.dateSignature).format("DD/MM/YYYY")  || ""
       // datePermissioning: node?.datePermissioning || ""
    };
}

export function validationSchema(node) {
    return Yup.object({
        entity: Yup.string().required("Required"),
        networkId: Yup.string().required("Required"),
        networkName: Yup.string().required("Required"),
        type: Yup.string().required("Required"),
        nameTechnicalContact: Yup.string().required("Required"),
        emailTechnicalContact: Yup.string().email("Format email invalid").required("Required"),
        phoneTechnicalContact: Yup.string().required("Required"),
        nameBussinesContact: Yup.string().required("Required"),
        emailBussinesContact: Yup.string().email("Format email invalid").required("Required"),
        phoneBussinesContact: Yup.string().required("Required"),
        enode: Yup.string().required("Required"),
        ipAddress: Yup.string().required("Required"),
        coinbase: Yup.string().required("Required"),
        portp2p: Yup.string().required("Required"),
        nodeNameEthstats: Yup.string().required("Required"),
        // membership: Yup.string().required("Required"),
        // datePermissioning: Yup.date().required("Date Required")
    });
}